export default {
    data() {
        return {
            locationOptions: [
                { value: 'none', text: 'No Location' },
                { value: 'Warehouse', text: 'Warehouse' },
                { value: 'Office', text: 'Office' },
                { value: 'Shipping', text: 'Shipping' },
                { value: 'In-Transit', text: 'In-Transit' },
                { value: 'Delivered', text: 'Delivered' },
                { value: 'Cancelled', text: 'Cancelled' },
                { value: 'Returned', text: 'Returned' },
                { value: 'RTS', text: 'Return to sender'},
                { value: 'Review', text: 'Manual Review' },
                { value: 'Lost In Mail (refunded)', text: 'Lost In Mail (refunded)' },
                { value: 'Not As Described Grade (refunded)', text: 'Not As Described Grade (refunded)' },
                { value: 'Not As Described Pressing (refunded)', text: 'Not As Described Pressing (refunded)' },
            ],
        }
    }
}